<template>
  <div class="app-sidebar" :style="{width: sideBarOpen ? '200px' : '65px'}">
    <transition enter-active-class="slideInRight" leave-active-class="slideInLeft">
      <el-menu
        :default-active="select"
        class="el-menu-sidebar"
        :collapse="!sideBarOpen"
        :unique-opened="true"
        @select="handleSelect"
      >
        <span v-for="bar in menu"
              :key="bar.key">
          <!--有子菜单-->
          <span v-if="bar.children.length">
            <el-submenu :index="bar.key">
              <template slot="title">
                <i class="el-icon-sidebar">
                  <img :src="bar.icon">
                </i>
                <span>{{bar.value}}</span>
              </template>
              <el-menu-item
                v-for="sub in bar.children"
                :key="sub.key"
                :index="sub.key">
                {{sub.value}}
              </el-menu-item>
            </el-submenu>
          </span>
          <!--无子菜单-->
          <span v-else>
            <el-menu-item :index="bar.key">
              <i class="el-icon-sidebar">
                <img :src="bar.icon">
              </i>
              <span slot="title">{{bar.value}}</span>
            </el-menu-item>
          </span>
        </span>
      </el-menu>
    </transition>
  </div>
</template>

<script type="text/ecmascript-6">
import AppSidebar from './AppSidebar.js'
export default AppSidebar
</script>

<style lang="scss">
@import "AppSidebar.scss";
</style>



// WEBPACK FOOTER //
// src/components/appSidebar/AppSidebar.vue